import PropTypes from 'prop-types';
import Icon from './Icon';

const Desktop = ({ stroke, strokeWidth, ...rest }) => (
  <Icon
    stroke={stroke}
    strokeWidth={strokeWidth}
    {...rest}
    path="M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V15C22 16.1046 21.1046 17 20 17H4C2.89543 17 2 16.1046 2 15V5Z"
  >
    <path
      d="M8 21H16"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17V21"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default Desktop;

Desktop.propTypes = {
  stroke: PropTypes.string.isRequired,
  strokeWidth: PropTypes.string.isRequired
};
